import { initializeGoogleAnalytics } from './googleAnalytics';

export const initializeAnalytics = () => {
  initializeGoogleAnalytics();
};
